import React from 'react';
import { CameraIcon, MessageSquareQuoteIcon, TruckIcon, MessageCircleIcon } from 'lucide-react';
import { CONTACT } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
const icons = [CameraIcon, MessageSquareQuoteIcon, TruckIcon];
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-sand py-20 lg:py-28" data-id="element-154" data-mp="3u0lienp5cy2a">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-155" data-mp="ljrxbh87v3p1">
        <div className="max-w-2xl" data-id="element-156" data-mp="lmcye40oxflq">
          <h2 className="font-display text-3xl font-black tracking-tight text-forest sm:text-4xl lg:text-5xl" data-id="element-157" data-mp="qjwdt794jyf9">
            {t.steps.title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-neutral-600" data-id="element-158" data-mp="crpytohpjxhe">
            {t.steps.intro}
          </p>
        </div>

        <ol className="mt-12 grid gap-8 md:grid-cols-3 md:gap-6" data-id="element-159" data-mp="14j5u06xbysj8">
          {t.steps.items.map((step, index) => {
          const Icon = icons[index];
          return <li key={step.number} className="relative flex gap-5 md:block" data-id="element-160" data-mp="19byz4vwpo2vu" data-mpi={index}>
                <div className="flex flex-col items-center md:block" data-id="element-161" data-mp="2rm7f0re617au">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-forest font-display text-sm font-black text-white" data-id="element-162" data-mp="2mncpz7plumia">
                    {step.number}
                  </span>
                  <span className="mt-2 h-full w-px bg-neutral-300 md:hidden" aria-hidden="true" data-id="element-163" data-mp="2wjz8hpugl1h5" />
                </div>
                <div className="pb-4 md:pb-0 md:pt-6" data-id="element-164" data-mp="3aacgfs7cog6h">
                  <Icon className="mb-3 hidden h-6 w-6 text-rust md:block" aria-hidden="true" data-id="element-165" data-mp="36bbzygcchpmn" />
                  <h3 className="font-display text-xl font-bold text-forest" data-id="element-166" data-mp="3kav6j4picswu">
                    {step.title}
                  </h3>
                  <p className="mt-2 max-w-sm text-[15px] leading-relaxed text-neutral-600" data-id="element-167" data-mp="3fbs1vldfwope">
                    {step.description}
                  </p>
                </div>
              </li>;
        })}
        </ol>

        <a href={CONTACT.whatsappHref} target="_blank" rel="noreferrer" className="mt-10 inline-flex items-center gap-2.5 rounded-md bg-whatsapp px-6 py-3.5 font-display text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-[#1DB456]" data-id="element-168" data-mp="1kzkauj48oryw">
          <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-169" data-mp="2tug8t9pplqv" />
          {t.steps.whatsappCta}
        </a>
      </div>
    </section>;
}